export const downloadPdf = (response: { buffer: string; mimeType: string; filename: string }) => {
    const byteCharacters = atob(response.buffer);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: response.mimeType });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = response.filename;

    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
};

